import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaTelegram,
} from "react-icons/fa";
import React from "react";
import { Link } from "react-router-dom";

export const PyFooter = () => {
  return (
    <>
      <footer className="bg-dark text-white pt-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <h3>
                <Link
                  className="text-light "
                  to="/"
                  style={{ fontWeight: "bold" }}
                >
                  WDSchool
                </Link>
              </h3>
              <h3 style={{ textAlign: "center" }}>Python Tutorial</h3>
              <hr />
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-4">
                    <h3 style={{ textAlign: "center" }}>Python Basic</h3>
                    <hr />
                    <ul className=" text-secondary table">
                      <li>
                        {" "}
                        <Link to="/FirstStep">Python – First Step</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/FirstProgram">Python – First Program</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/Variable">Python – Variable</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/DataType">Python – Data Types</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/Operators">Python – Operators</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/Input">Python – Input</Link>
                      </li>
                      {/* <li>
                        {" "}
                        <Link to="">Python – Print</Link>
                      </li> */}
                      <li>
                        {" "}
                        <Link to="/DecisionMaking">
                          Python – If Else, Decision Making
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <h3 style={{ textAlign: "center" }}>Python Intermediate</h3>
                    <hr />
                    <ul className=" text-secondary table">
                      <li>
                        {" "}
                        <Link to="/WhileLoop">Python – While Loop</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/ForLoop">Python – For Loops</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/Break">Python – Break, Continue & Pass</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/List">List in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/Tuple">Tuple in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Dictionary in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Set in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">String in Python</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <h3 style={{ textAlign: "center" }}>Python Advance</h3>
                    <hr />
                    <ul className=" text-secondary table">
                      <li>
                        {" "}
                        <Link to="">Function in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Module in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Python Exception Handling</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Python File Handling</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">
                          Python OOPS – Object Oriented Programming System
                        </Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">class and Object in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Inheritance in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Python Database Connection</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-2"></div> */}
            <div className="col-md-4">
              <h3 style={{ marginLeft: "90px" }}>
                Web Development<span className="text-primary"> School</span>
              </h3>

              <ul className="list-unstyled text-secondary  text-md-end mt-5">
                <li>SECTOR 16,NOIDA - SOUTH EX. - PITAMPURA - GURUGRAM</li>
                <li>
                  WDSchool:{" "}
                  <span className="text-primary">99-10-93-50-66 </span>
                </li>
                <li>
                  {" "}
                  Learn Coding With{" "}
                  <span className="text-primary">Rahul Katoch</span>{" "}
                </li>
              </ul>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-md-3 mt-5">
              <h2> Request a Call Back</h2>
              <h3 className="text-primary"> 99-10-93-50-66</h3>
            </div>
            <div className="col-md-5 mt-4 d-flex flex-column justify-content-center align-items-center">
              <p className="bg-primary pt-1"> Follow Us </p>
              <div style={{ fontFamily: "sans-serif", textAlign: "center" }}>
                <a href="https://www.facebook.com/rahul.katoch.9231">
                  <FaFacebookSquare />
                </a>

                <a
                  href="https://www.instagram.com/official_rahulkatoch/?igshid=YmMyMTA2M2Y%3D"
                  style={{ paddingLeft: "12px" }}
                >
                  <FaInstagram />
                </a>

                <a
                  href="www.linkedin.com/in/rahul-katoch-088a7b206"
                  style={{ paddingLeft: "12px" }}
                >
                  <FaLinkedin />
                </a>

                <a href="" style={{ paddingLeft: "12px" }}>
                  <FaTelegram />
                </a>
              </div>
            </div>

            <div className="col-md-4 mt-5">
              <img
                className="img-fluid"
                src="https://www.kindpng.com/picc/m/48-480088_payment-method-credit-card-master-card-hd-png.png"
                alt=""
              />
            </div>
          </div>
          <br />
          <div className="copyright  bg-primary py-4 mt-2">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <small>
                    Privacy Policy || Terms of Use || Career || Blog
                  </small>
                </div>
                <div className="col-md-6">
                  <small>
                    © Copyright 2022 Rahul Katoch , All rights reserved.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
